import {
  Button,
  DialogActions as MaterialDialogActions,
  DialogContent as MaterialDialogContent,
  DialogTitle as MaterialDialogTitle,
} from '@mui/material';
import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const DialogContent = styled(MaterialDialogContent)`
  padding: 0 32px !important;
`;

export const DialogTitle = styled(MaterialDialogTitle)`
  padding: 32px 32px 16px 32px !important;

  && {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
  }
`;
export const DialogActions = styled(MaterialDialogActions)<{$align: string}>`
  justify-content: ${({$align}) =>
    $align === 'left' ? 'flex-start' : 'flex-end'} !important;
  padding: 24px 32px 32px 32px !important;

  button:first-child {
    margin-right: 8px !important;
  }
`;

const MaterialButtonTextStyles = css`
  && {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const DestructiveButton = styled(Button)`
  background-color: ${globals.THEME.statusErrorText} !important;
  color: white !important;
  border-radius: 4px;

  :hover {
    background-color: ${globals.THEME.statusErrorText} !important;
  }

  ${MaterialButtonTextStyles}
`;

export const GhostButton = styled(Button)`
  border-radius: 4px;

  ${MaterialButtonTextStyles}
`;
